import React, { useState } from 'react'
import { Alert, Button, Space, Typography, theme } from 'antd'
import { useSelector, useDispatch } from 'react-redux'
import { rubricRefinementSelectors } from '../../../../../../../store/selectors/rubricRefinement.selectors'
import { CheckOutlined, DownOutlined, RightOutlined } from '@ant-design/icons'
import { getCategoryById } from '../../../../../../../store/apis/utils/selectors/question.api.selectors'
import PatternIcon from '../../../../../../../components/common/PatternIcon'
import { setHoveredCategoryId } from '../../../../../../../store/slices/rubric-refinement.slice'
import MarkdownRenderer from '../../../../../../../components/common/markdown-renderer/MarkdownRenderer'
import { useRefinementFlow } from '../hooks/useRefinementFlow'
const { Text } = Typography

const CategoryCard = ({ category, refinementItemId, isDisabled, questions }) => {
    const { handleCategorySelect } = useRefinementFlow()
    const refinementItem = useSelector(state => rubricRefinementSelectors.refinementItemById(state, refinementItemId))
    const isSelected = refinementItem?.selectedCategoryId === category.id
    const categoryDetails = getCategoryById(questions, category.id)
    const { token: themeToken } = theme.useToken()
    const dispatch = useDispatch()
    const [isExpanded, setIsExpanded] = useState(false)

    const handleCategoryChoice = () => {
        if (isDisabled) return
        handleCategorySelect(refinementItemId, category.id)
    }

    const handleMouseEnter = () => {
        dispatch(setHoveredCategoryId(category.id))
    }

    const handleMouseLeave = () => {
        dispatch(setHoveredCategoryId(null))
    }

    return (
        <div onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave} style={{ height: '100%' }}>
            <Button
                className={`category-choice__option ${isDisabled ? 'disabled' : ''}`}
                type='text'
                onClick={handleCategoryChoice}
                style={{
                    backgroundColor: isSelected ? themeToken.colorSuccessBg : themeToken.colorBgContainer,
                    borderColor: isSelected ? themeToken.colorSuccess : null,
                    padding: '16px',
                    height: '100%',
                    width: '100%',
                    position: 'relative',
                }}
            >
                <Space direction='vertical' style={{ width: '100%', height: '100%' }} size='middle' align='start'>
                    <Space align='start'>
                        <Text
                            type='secondary'
                            strong
                            style={{ fontSize: '14px', wordBreak: 'break-word', whiteSpace: 'pre-wrap' }}
                        >
                            {categoryDetails && (
                                <PatternIcon
                                    id={category.id}
                                    colorId={categoryDetails?.colorId}
                                    content={categoryDetails?.grade}
                                    type='pattern'
                                    color={categoryDetails?.color}
                                    suffix='pt'
                                    style={{ marginRight: '8px', fontWeight: 'normal' }}
                                />
                            )}
                            {categoryDetails?.name}
                        </Text>
                        {isSelected && <CheckOutlined style={{ color: themeToken.colorSuccess }} />}
                    </Space>
                    {/* {category.tags?.length > 0 && (
                        <Space wrap>
                            {category.tags.map(tag => (
                                <CategoryCardTag key={tag} tag={tag} />
                            ))}
                        </Space>
                    )} */}

                    <MarkdownRenderer
                        content={category.description}
                        type='secondary'
                        style={{ width: '100%', wordBreak: 'break-word', whiteSpace: 'pre-wrap' }}
                    />
                    <Alert
                        onClick={e => {
                            e.stopPropagation()
                            setIsExpanded(prev => !prev)
                        }}
                        style={{
                            cursor: 'pointer',
                            backgroundColor: 'transparent'
                        }}
                        message={
                            <Text
                                type='secondary'
                                style={{
                                    fontSize: '14px',
                                    wordBreak: 'break-word',
                                    whiteSpace: isExpanded ? 'pre-wrap' : undefined,
                                }}
                            >
                                <Text strong type='secondary' style={{ display: 'flex', alignItems: 'center' }}>
                                    Why It {category.isAdequate ? 'Does' : 'Does Not'} Apply?
                                    {isExpanded ? (
                                        <DownOutlined style={{ marginLeft: '4px', fontSize: '12px' }} />
                                    ) : (
                                        <RightOutlined style={{ marginLeft: '4px', fontSize: '12px' }} />
                                    )}
                                </Text>
                                {isExpanded && category.explanation}
                            </Text>
                        }
                        type={category.isAdequate ? 'info' : 'warning'}
                    />
                </Space>
            </Button>

        </div>
    )
}

export default CategoryCard
